/* Prestige Wear — Neige de Noël
   Décor uniquement : aucun impact sur le clic, aucune requête réseau,
   arrêté sur mobile, quand l'onglet est en arrière-plan, et pour les
   visiteurs qui limitent les animations. */
(function () {
  'use strict';

  var FLAKES = ['❄', '❅', '❆', '•'];
  var MOBILE = window.matchMedia('(max-width: 749px)').matches;
  var COUNT = MOBILE ? 12 : 22;

  function build() {
    var host = document.getElementById('xmasSnow');
    if (!host || host.dataset.built === 'true') return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var fragment = document.createDocumentFragment();

    for (var i = 0; i < COUNT; i++) {
      var flake = document.createElement('span');
      flake.className = 'xmas-snow__flake';
      flake.textContent = FLAKES[i % FLAKES.length];
      flake.style.left = (Math.random() * 100).toFixed(2) + 'vw';
      var base = MOBILE ? 0.4 : 0.5;
      flake.style.fontSize = (base + Math.random() * (MOBILE ? 0.45 : 0.8)).toFixed(2) + 'rem';
      flake.style.opacity = (0.35 + Math.random() * 0.4).toFixed(2);
      flake.style.setProperty('--drift', (Math.random() * 120 - 60).toFixed(0) + 'px');
      flake.style.animationDuration = (11 + Math.random() * 12).toFixed(1) + 's';
      flake.style.animationDelay = '-' + (Math.random() * 18).toFixed(1) + 's';
      fragment.appendChild(flake);
    }

    host.appendChild(fragment);
    host.dataset.built = 'true';

    document.addEventListener('visibilitychange', function () {
      host.style.animationPlayState = document.hidden ? 'paused' : 'running';
      var flakes = host.children;
      for (var j = 0; j < flakes.length; j++) {
        flakes[j].style.animationPlayState = document.hidden ? 'paused' : 'running';
      }
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(build, { timeout: 2500 });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
})();
